module.exports = __webpack_public_path__ + "img/atmosphere01.c6c0491c.png";